// Reducers
import applicantReducer from "./applicants";
import communityCenterReducer from "./communityCenters";
import companiesReducer from "./companies";
import errorsReducer from "./errors";
import evaluationsReducer from "./evaluations";
import programsReducer from "./programs";
import registrationsReducer from "./registrations";
import requestsReducer from "./requests";
import supervisorReducer from "./supervisors";
import tablesReducer from "./tables";
import UsherReducer from "./ushers";

const rootReducer = {
  rootTables: tablesReducer,
  rootErrors: errorsReducer,
  rootApplicants: applicantReducer,
  rootSupervisors: supervisorReducer,
  rootPrograms: programsReducer,
  rootRequests: requestsReducer,
  rootCompanies: companiesReducer,
  rootRegistrations: registrationsReducer,
  rootEvaluations: evaluationsReducer,
  rootUshers: UsherReducer,
  rootCommunityCenters: communityCenterReducer,
};

export default rootReducer;
